import { useEffect, useState } from 'react';
import api from '@/lib/api';

/**
 * Loads GET /api/page/case-studies for the list page.
 * Returns nulls while loading or on error.
 */
export function useCaseStudiesData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/page/case-studies')
      .then((res) => { if (!cancelled) setData(res.data?.data || null); })
      .catch(() => { if (!cancelled) setData(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { data, loading };
}
